import { render, staticRenderFns } from "./shimmer.vue?vue&type=template&id=2ba9404c&scoped=true"
var script = {}
import style0 from "./shimmer.vue?vue&type=style&index=0&id=2ba9404c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba9404c",
  null
  
)

export default component.exports